import { apiGet, apiPatch, apiPost } from './httpClient'

export const getCacheConfigs = async () => {
  try {
    const response = await apiGet('/cache-configs/')
    return response.data || []
  } catch (error) {
    console.error('Error fetching cache configs:', error)
    throw error
  }
}

export const updateCacheConfig = async (configId, data) => {
  try {
    const response = await apiPatch(`/cache-configs/${configId}/`, data)
    return response
  } catch (error) {
    console.error('Error updating cache config:', error)
    throw error
  }
}

export const getCacheStats = async () => {
  try {
    const response = await apiGet('/cache-configs/stats/')
    return response
  } catch (error) {
    console.error('Error fetching cache stats:', error)
    throw error
  }
}

export const clearCache = async (cacheType) => {
  try {
    const response = await apiPost('/cache-configs/clear/', { cache_type: cacheType })
    return response
  } catch (error) {
    console.error('Error clearing cache:', error)
    throw error
  }
}